<template>
  <div>
    <b-card>
      <div>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-modal.modal-primaryadd
          variant="outline-primary"
          class="m-1"
        >
          Добавить
        </b-button>
        <app-table
          responsive="sm"
          :items="items"
          :fields="tableColumns"
          :loading="loading"
        >
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <b-button
                id="gradient-primaryy"
                v-b-modal.modal-primaryedit
                class="btn-icon mr-1"
                variant="gradient-primary"
                @click="edit(data.item)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                class="btn-icon"
                variant="gradient-danger"
                @click="confirmDelete(data.item)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
              <b-dropdown
                :right="$store.state.appConfig.isRTL"
                no-caret
                toggle-class="p-0"
                variant="link"
              />
            </div>
          </template>
          <template #cell(path)="data">
            <img
              class="mr-1"
              :src="data.item.path"
              width="65"
              height="40"
            >
          </template>
        </app-table>
        <b-modal
          id="modal-primaryadd"
          ok-title="Сохранить"
          cancel-title="Закрыть"
          modal-class="modal-primary"
          centered
          title="Добавление"
          :busy="submitting"
          :no-close-on-backdrop="submitting"
          :no-close-on-esc="submitting"
          :hide-header-close="submitting"
          @ok="onAdd"
          @hidden="resetAddModal"
        >
          <validation-observer ref="addRules">
            <fieldset :disabled="submitting">
              <b-row>
              <b-col cols="12">
                <b-form-group
                  label="Слайдер моб.устройств"
                  label-for="imageMob"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="mobile_image"
                    rules="required"
                  >
                    <b-form-file
                      id="imageMob"
                      :key="`mob-add-${addFileKey}`"
                      v-model="addBanner.imageMob"
                      size="lg"
                      placeholder="Выберите изображение..."
                      drop-placeholder="Slide..."
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label="Слайдер для для декстопа"
                  label-for="imageDesk"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="image"
                    rules="required"
                  >
                    <b-form-file
                      id="imageDesk"
                      :key="`desk-add-${addFileKey}`"
                      v-model="addBanner.image"
                      size="lg"
                      placeholder="Выберите изображение..."
                      drop-placeholder="Slide..."
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Заголовок"
                  label-for="title"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="title"
                    rules="required"
                  >
                    <b-form-input
                      id="title"
                      v-model="addBanner.title"
                      placeholder="Заголовок"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Тип баннера"
                  label-for="type"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="type"
                    rules="required"
                  >
                    <b-form-select
                      id="type"
                      v-model="addBanner.type"
                      :options="types"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Описание"
                  label-for="description"
                >
                  <b-form-input
                    id="description"
                    v-model="addBanner.description"
                    placeholder="Описание"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Название кнопки"
                  label-for="link_name"
                >
                  <b-form-input
                    id="link_name"
                    v-model="addBanner.link_name"
                    placeholder="Название кнопки"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Ссылка на кнопку"
                  label-for="link"
                >
                  <b-form-input
                    id="link"
                    v-model="addBanner.link"
                    placeholder="Ссылка на кнопку"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Фон кнопки"
                  label-for="link_bg"
                >
                  <b-form-input
                    id="link_bg"
                    v-model="addBanner.link_bg"
                    placeholder="Фон кнопки"
                    type="color"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Актив"
                >
                  <b-form-select
                    v-model="addBanner.is_active"
                    :options="options"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            </fieldset>
          </validation-observer>
        </b-modal>
        <b-modal
          id="modal-primaryedit"
          ok-title="Редактировать"
          cancel-title="Закрыть"
          modal-class="modal-primary"
          centered
          title="Редактирование"
          :busy="submitting"
          :no-close-on-backdrop="submitting"
          :no-close-on-esc="submitting"
          :hide-header-close="submitting"
          @ok="onEdit"
          @hidden="resetEditModal"
        >
          <validation-observer ref="editRules">
            <fieldset :disabled="submitting">
              <b-row>
              <b-col cols="12">
                <b-form-group
                  label="Слайдер моб.устройств"
                  label-for="imageMobEdit"
                >
                  <b-form-file
                    id="imageMobEdit"
                    :key="`mob-edit-${editFileKey}`"
                    v-model="editBanner.imageMob"
                    size="lg"
                    placeholder="Выберите изображение..."
                    drop-placeholder="Slide..."
                  />
                </b-form-group>
                <b-form-group
                  label="Слайдер для для декстопа"
                  label-for="imageDeskEdit"
                >
                  <b-form-file
                    id="imageDeskEdit"
                    :key="`desk-edit-${editFileKey}`"
                    v-model="editBanner.image"
                    size="lg"
                    placeholder="Выберите изображение..."
                    drop-placeholder="Slide..."
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Заголовок"
                  label-for="titleEdit"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="title"
                    rules="required"
                  >
                    <b-form-input
                      id="titleEdit"
                      v-model="editBanner.title"
                      placeholder="Заголовок"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Тип баннера"
                  label-for="typeEdit"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="type"
                    rules="required"
                  >
                    <b-form-select
                      id="typeEdit"
                      v-model="editBanner.type"
                      :options="types"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Описание"
                  label-for="descriptionEdit"
                >
                  <b-form-input
                    id="descriptionEdit"
                    v-model="editBanner.description"
                    placeholder="Описание"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Название кнопки"
                  label-for="link_nameEdit"
                >
                  <b-form-input
                    id="link_nameEdit"
                    v-model="editBanner.link_name"
                    placeholder="Название кнопки"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Ссылка на кнопку"
                  label-for="linkEdit"
                >
                  <b-form-input
                    id="linkEdit"
                    v-model="editBanner.link"
                    placeholder="Ссылка на кнопку"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Фон кнопки"
                  label-for="link_bgEdit"
                >
                  <b-form-input
                    id="link_bgEdit"
                    v-model="editBanner.link_bg"
                    placeholder="Фон кнопки"
                    type="color"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Порядок"
                  label-for="orderEdit"
                >
                  <b-form-input
                    id="orderEdit"
                    v-model="editBanner.order"
                    placeholder="Порядок"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Актив"
                >
                  <b-form-select
                    v-model="editBanner.is_active"
                    :options="options"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            </fieldset>
          </validation-observer>
        </b-modal>
      </div>
      <b-pagination-nav
        v-if="numberOfPages > 1"
        :value="currentPage"
        :number-of-pages="numberOfPages"
        :link-gen="pageLink"
        :disabled="loading"
        use-router
        hide-goto-end-buttons
      />
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import {
  BFormSelect, BCard, BDropdown, BFormFile, BFormInput, BFormGroup, VBModal, BModal, BRow, BCol, BButton, BPaginationNav,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import { $themeConfig } from '@themeConfig'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppTable from '@/components/AppTable.vue'
import routePagination from '@/mixins/routePagination'
import { codeSeparated } from './Pagination/code'

const getDefaultBanner = () => ({
  id: '',
  image: null,
  imageMob: null,
  type: '',
  is_active: 1,
  title: '',
  description: '',
  link: '',
  link_name: '',
  link_bg: '',
  order: '',
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BFormFile,
    BFormInput,
    BFormGroup,
    AppTable,
    BRow,
    BCol,
    BButton,
    BModal,
    BDropdown,
    BFormSelect,
    BPaginationNav,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [routePagination],
  data() {
    return {
      required,
      IMG_URL: $themeConfig.app.IMG_URL,
      tableColumns: [
        {
          key: 'id',
          label: '#',
        },
        {
          key: 'path',
          label: 'Изображение',
        },
        {
          key: 'title',
          label: 'Название',
        },
        {
          key: 'type',
          label: 'Тип',
        },
        {
          key: 'order',
          label: 'Порядок',
        },
        {
          key: 'link',
          label: 'Ссылка',
        },
        {
          key: 'link_name',
          label: 'Кнопка',
        },
        {
          key: 'actions',
          label: 'Действия',
        },
      ],
      submitting: false,
      addBanner: getDefaultBanner(),
      editBanner: getDefaultBanner(),
      options: [
        { value: 1, text: 'Да' },
        { value: 0, text: 'Нет' },
      ],
      types: [
        { value: 'slider', text: 'Слайдер' },
        { value: 'main', text: 'Главный баннер' },
        { value: 'category', text: 'Категория' },
        { value: 'filter', text: 'Фильтр' },
      ],
      codeSeparated,
      addFileKey: 0,
      editFileKey: 0,
    }
  },
  methods: {
    // Called by the routePagination mixin
    fetchItems({ page, perPage }) {
      return axios
        .get(`${$themeConfig.app.API}v2/admin/banners`, {
          params: {
            per_page: perPage,
            page,
          },
        })
        .then(res => ({
          items: res.data.data,
          total: res.data.meta.total,
          perPage: res.data.meta.per_page,
        }))
    },
    async onAdd(bvModalEvt) {
      bvModalEvt.preventDefault()
      const valid = await this.$refs.addRules.validate()
      if (!valid) return
      const ok = await this.add()
      if (ok) this.$bvModal.hide('modal-primaryadd')
    },
    async onEdit(bvModalEvt) {
      bvModalEvt.preventDefault()
      const valid = await this.$refs.editRules.validate()
      if (!valid) return
      const ok = await this.handleEdit()
      if (ok) this.$bvModal.hide('modal-primaryedit')
    },
    async add() {
      const myFormData = new FormData()
      myFormData.append('type', this.addBanner.type)
      myFormData.append('is_active', this.addBanner.is_active)
      myFormData.append('description', this.addBanner.description || '')
      myFormData.append('link', this.addBanner.link || '')
      myFormData.append('link_name', this.addBanner.link_name || '')
      myFormData.append('link_bg', this.addBanner.link_bg || '')
      myFormData.append('title', this.addBanner.title || '')
      myFormData.append('order', this.addBanner.order || 0)
      if (this.addBanner.image instanceof File) {
        myFormData.append('image', this.addBanner.image)
      }
      if (this.addBanner.imageMob instanceof File) {
        myFormData.append('mobile_image', this.addBanner.imageMob)
      }
      this.submitting = true
      try {
        await axios.post(`${$themeConfig.app.API}v2/admin/banners`, myFormData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'application/json',
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        })
      } catch (e) {
        const errors = e.response?.data?.errors
        if (e.response?.status === 422 && errors) {
          this.$refs.addRules.setErrors(errors)
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Ошибка',
              text: e.message,
              icon: 'CheckSquareIcon',
              variant: 'danger',
            },
          })
        }
        return false
      } finally {
        this.submitting = false
      }
      this.loadItems()
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Успешно',
          text: 'Запись успешно добавлен',
          icon: 'CheckSquareIcon',
          variant: 'success',
        },
      })
      return true
    },
    resetAddModal() {
      this.addBanner = getDefaultBanner()
      this.addFileKey += 1
      if (this.$refs.addRules) this.$refs.addRules.reset()
    },
    resetEditModal() {
      this.editBanner = getDefaultBanner()
      this.editFileKey += 1
      if (this.$refs.editRules) this.$refs.editRules.reset()
    },
    async handleEdit() {
      if (this.editBanner.id === '') return false
      const myFormData = new FormData()
      myFormData.append('type', this.editBanner.type)
      myFormData.append('title', this.editBanner.title || '')
      myFormData.append('description', this.editBanner.description || '')
      myFormData.append('is_active', this.editBanner.is_active)
      myFormData.append('order', this.editBanner.order || '0')
      myFormData.append('link', this.editBanner.link || '')
      myFormData.append('link_name', this.editBanner.link_name || '')
      myFormData.append('link_bg', this.editBanner.link_bg || '')
      myFormData.append('_method', 'put')
      if (this.editBanner.image instanceof File) {
        myFormData.append('image', this.editBanner.image)
      }
      if (this.editBanner.imageMob instanceof File) {
        myFormData.append('mobile_image', this.editBanner.imageMob)
      }
      this.submitting = true
      try {
        await axios.post(`${$themeConfig.app.API}v2/admin/banners/${this.editBanner.id}`, myFormData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'application/json',
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        })
      } catch (e) {
        const errors = e.response?.data?.errors
        if (e.response?.status === 422 && errors) {
          this.$refs.editRules.setErrors(errors)
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Ошибка',
              text: e.message,
              icon: 'CheckSquareIcon',
              variant: 'danger',
            },
          })
        }
        return false
      } finally {
        this.submitting = false
      }
      this.loadItems()
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Успешно',
          text: 'Данные были изменены',
          icon: 'CheckSquareIcon',
          variant: 'success',
        },
      })
      return true
    },
    edit(data) {
      this.editBanner = {
        ...getDefaultBanner(),
        id: data.id,
        type: data.type,
        is_active: data.is_active,
        title: data.title,
        description: data.description,
        link: data.link,
        link_name: data.link_name,
        link_bg: data.link_bg,
        order: data.order,
      }
      this.editFileKey += 1
    },
    confirmDelete(data) {
      this.$bvModal
        .msgBoxConfirm('После удаления данные восстановить нельзя будет!', {
          title: 'Вы уверены что хотите удалить?',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Удалить',
          cancelTitle: 'Отменить',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            axios.delete(`${$themeConfig.app.API}v2/admin/banners/${data.id}`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              },
            })
              .then(() => {
                this.loadItems()
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Успешно',
                    text: 'Данные были удалены',
                    icon: 'CheckSquareIcon',
                    variant: 'success',
                  },
                })
              })
              .catch(e => {
                console.log(e)
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Ошибка',
                    text: e.message,
                    icon: 'CheckSquareIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    getBase64(image) {
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => {
          resolve(reader.result)
        }
        reader.readAsDataURL(image)
      })
    },
  },
}
</script>
